import React from "react";
import { connect } from "react-redux";
import { CallbackComponent } from "redux-oidc";
// import { push } from "react-router-redux";
import userManager from "../../helpers/userManage";

class CallbackPage extends React.Component {
  render() {
    return (
      <CallbackComponent
        userManager={userManager}
        successCallback={(user) => {
          const path = user.state.path
          this.props.history.push(path);
        }}
        errorCallback={error => {
         // console.error('eee', error);
          this.props.history.push('/');
        }}
      >
        <div>Redirecting...</div>
      </CallbackComponent>
    );
  }
}

export default connect()(CallbackPage);
